import { render, staticRenderFns } from "./Pacman.container.vue?vue&type=template&id=2974a0cd&scoped=true&"
import script from "./Pacman.container.vue?vue&type=script&lang=js&"
export * from "./Pacman.container.vue?vue&type=script&lang=js&"
import style0 from "./Pacman.container.vue?vue&type=style&index=0&id=2974a0cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974a0cd",
  null
  
)

export default component.exports